export const PENDING_PLACEHOLDER_HTML = `
<div class="__visually_element_placeholder">
  <div class="vsly-card">
    <span class="vsly-plus" style="position: absolute">+</span>
    <div class="vsly-spinner-wrapper">
      <img src="https://sdk.loomi-prod.xyz/VSLY/logo-black.webp"/>
      <div class="vsly-spinner-container">
        <span class="vsly-gen-spinner-bg"></span>
        <span class="vsly-gen-spinner"></span>
      </div>
      <div class="vsly-success-mark">
        <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Path 62</title>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <g id="Path-62" transform="translate(3.2355, 3.3278)" stroke="#000000" stroke-width="5">
                  <polyline id="Path-61" points="0 4.20395078 5.20377478 9.40772556 12.7644643 8.07727678e-16"></polyline>
              </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
  <div class="vsly-rainbow-bg"/>
</div>
`;

export const PLACEHOLDER_CSS = `
.__visually_element_placeholder {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 2px;
  height: 50vw;
  @media screen and (min-width: 1024px) {
    height: 25vw;
  }
}

.__visually_element_placeholder .vsly-rainbow-bg {
  position: absolute;
  inset: 0;
  border-radius: 3px;
  margin: 8px;
  filter: blur(6px);
  background: linear-gradient(
      110deg,
      #BF85FF,
      #F091E7,
      #FFB0D8,
      #FFCECC,
      #BF85FF,
      #F091E7,
      #FFB0D8,
      #FFCECC,
      #BF85FF,
      #F091E7,
      #FFB0D8,
      #FFCECC,
      #BF85FF,
      #F091E7,
      #FFB0D8,
      #FFCECC
    );
  z-index: -1;
  background-size: 400% 400%;
  animation: rainbow 18s linear infinite;
  animation-play-state: paused;
  z-index: 1;
}

@keyframes rainbow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 1% 50%;
  }
}

.__visually_element_placeholder .vsly-spinner-wrapper {
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  width: 100%;
  transition: opacity 0.5s ease-in-out;
}

.__visually_element_placeholder .vsly-spinner-wrapper img {
  height: 20px;
  width: 20px;

  @media screen and (min-width: 1024px) {
    height: 25px;
    width: 25px;
  }
}

.__visually_element_placeholder .vsly-spinner-container {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  inset: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.__visually_element_placeholder .vsly-gen-spinner-bg {
  border: 3px solid #97979720;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  position: absolute;

  @media screen and (min-width: 1024px) {
    height: 60px;
    width: 60px;
  }
}

.__visually_element_placeholder .vsly-gen-spinner {
  display: block;
  border: 3px solid black;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 3s loader linear infinite;
  position: absolute;
  height: 50px;
  width: 50px;

  @media screen and (min-width: 1024px) {
    height: 50px;
    width: 50px;
  }
}

@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.__visually_element_placeholder .vsly-card {
  position: absolute;
  inset: 0;
  margin: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: calc(100% - 16px);
  width: calc(100% - 16px);
  background: white;
  border-radius: 8px;
  z-index: 1;
  font-size: 40px;
  background-image: linear-gradient(to bottom, #f5f5f5, #fff);
  z-index: 2;
}

.__visually_element_placeholder .vsly-plus {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.__visually_element_placeholder .vsly-success-mark {
  position: absolute;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
`;

export const PLACEHOLDER_JS = `
  let vslyPlaceholderStyles = document.querySelector('#__vsly_placeholder_styles');
  if (!vslyPlaceholderStyles) {
    vslyPlaceholderStyles = document.createElement('style');
    vslyPlaceholderStyles.id = '__vsly_placeholder_styles';
    vslyPlaceholderStyles.innerHTML = "";
    document.head.appendChild(vslyPlaceholderStyles);
  }

  window.addEventListener("message", (ev) => {
    if (ev.data?.tpe === "vsly-placeholder-state-changed") {
      if (ev.data.state === "loading") {
        vslyPlaceholderStyles.innerHTML = ".__visually_element_placeholder .vsly-spinner-wrapper { opacity: 1!important; } .__visually_element_placeholder .vsly-plus { opacity: 0!important; } .__visually_element_placeholder .vsly-success-mark { opacity: 0!important; } .__visually_element_placeholder .vsly-rainbow-bg { animation-play-state: running!important; }";
      } else if (ev.data.state === "idle") {
        vslyPlaceholderStyles.innerHTML = ".__visually_element_placeholder .vsly-spinner-wrapper { opacity: 0!important; } .__visually_element_placeholder .vsly-plus { opacity: 1!important; } .__visually_element_placeholder .vsly-success-mark { opacity: 0!important; } .__visually_element_placeholder .vsly-rainbow-bg.loading { animation-play-state: paused!important; }";
      } else if (ev.data.state === "success") {
        vslyPlaceholderStyles.innerHTML = ".__visually_element_placeholder .vsly-spinner-wrapper { opacity: 0!important; } .__visually_element_placeholder .vsly-plus { opacity: 0!important; } .__visually_element_placeholder .vsly-success-mark { opacity: 1!important; } .__visually_element_placeholder .vsly-rainbow-bg.loading { animation-play-state: paused!important; } ";
      }
    }
  })
`;
